<template>
	<v-dialog v-model="dialog" persistent max-width="800px">
		<v-card>
			<v-toolbar flat dense>
				<v-toolbar-title class="subheading">Version History</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn icon @click="onCancelClick">
					<v-icon>close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-data-table :headers="headers" :items="history" hide-actions class="history-list elevation-1" :pagination.sync="pagination">
				<template slot="items" slot-scope="props">
					<tr :class="{ current: props.item.isCurrent }">
						<td class="text-xs-left">
							<div v-if="props.item.isCurrent">
								<strong>{{ props.item.versionNo }}</strong>
								<v-chip outline class="ml-3" color="info" small dark>Current Version</v-chip>
							</div>
							<span v-else>{{ props.item.versionNo }}</span>
						</td>
						<td class="text-xs-left">
							<AppDate :date="props.item.fromDateUTC" show-date format="Do MMM YYYY" />
						</td>
						<td class="text-xs-left">
							<span v-if="props.item.isCurrent">-</span>
							<AppDate v-else :date="props.item.toDateUTC" show-date format="Do MMM YYYY" />
						</td>
						<td class="text-xs-right">
							<a v-if="showViewPreviousVersionButton(props.item)" href="#" @click.prevent.stop="viewDocument(props.item.versionNo)">View Document</a>
						</td>
						<td v-if="showDiffColumn" class="text-xs-right pl-0" style="width: 1px">
							<v-tooltip bottom>
								<template v-slot:activator="{ on }">
									<v-btn v-if="showViewChangesButton(props.item)" v-on="on" small icon @click.prevent.stop="viewDiff(props.item.versionNo)"><v-icon>mdi-file-compare</v-icon></v-btn>
								</template>
								<span>View Changes</span>
							</v-tooltip>
						</td>
					</tr>
				</template>
			</v-data-table>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn flat @click="onCancelClick">Cancel</v-btn>
			</v-card-actions>
		</v-card>

		<hr-document-diff-dialog v-if="showDiffDialog" :hrDocumentId="hrDocument.id" :versionNo="selectedVersionNo" @onCancel="showDiffDialog = false" />

		<hr-document-previous-version-dialog v-if="showPreviousVersionDialog" :dialog="showPreviousVersionDialog" :id="hrDocument.id" :versionNo="selectedVersionNo" @closeDialog="showPreviousVersionDialog = false" />
	</v-dialog>
</template>

<script>
	import hrDocumentDiffDialog from '@/components/hrDocuments/HrDocumentDiffDialog';
	import hrDocumentPreviousVersionDialog from '@/components/hrDocuments/HrDocumentPreviousVersionDialog';

	export default {
		components: { hrDocumentDiffDialog, hrDocumentPreviousVersionDialog },
		props: {
			dialog: {
				required: true
			},
			hrDocument: {
				type: Object,
				required: true
			}
		},
		data() {
			return {
				headers: [
					{ text: 'Version', value: 'versionNo' },
					{ text: 'From Date', value: 'fromDateUTC' },
					{ text: 'To Date', value: 'toDateUTC' }
				],
				pagination: { sortBy: 'versionNo', descending: true, rowsPerPage: 10 },
				showDiffDialog: false,
				showPreviousVersionDialog: false,
				selectedVersionNo: null
			};
		},
		computed: {
			history() {
				const historyMapped = this.hrDocument.history.map((h) => {
					return {
						versionNo: h.versionNo,
						fromDateUTC: h.fromDateUTC,
						toDateUTC: h.toDateUTC,
						isCurrent: false
					};
				});

				const current = {
					versionNo: this.hrDocument.versionNo,
					fromDateUTC: this.hrDocument.lastUpdatedDateUTC,
					toDateUTC: null,
					isCurrent: true
				};

				historyMapped.unshift(current);

				return historyMapped;
			},
			isContentText() {
				return this.hrDocument.contentType === 0;
			},
			showDiffColumn() {
				return this.isContentText;
			}
		},
		methods: {
			onCancelClick() {
				this.$emit('onCancel');
			},
			viewDiff(versionNo) {
				this.selectedVersionNo = versionNo;
				this.showDiffDialog = true;
			},
			showViewChangesButton(historyItem) {
				return this.isContentText && historyItem.versionNo > 1;
			},
			showViewPreviousVersionButton(historyItem) {
				return !historyItem.isCurrent;
			},
			viewDocument(versionNo) {
				this.selectedVersionNo = versionNo;
				this.showPreviousVersionDialog = true;
			}
		}
	};
</script>

<style scoped>
	.history-list >>> tr.current td {
		background-color: rgb(0 121 255 / 10%);
	}
</style>